/// <reference path='../../../../typings/index.d.ts' />
/// <reference path='../../components/baseclasses/guid.ts' />
/// <reference path='../../components/models/meevo.model.custom.ts' />

module Meevo.Plugins.EmployeeTemplatePromotions {
    'use strict';

    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;

    export class EmployeeTemplatePromotionsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        employeeDetail: Model.DataDetail;
        appliedTemplates: string[];

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            private $translate: angular.translate.ITranslateService,
            _employeeDetail: Model.DataDetail) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

            this.employeeDetail = _employeeDetail;
            this.appliedTemplates = new Array();
            this.initializeContext();
            this.initializeSections();
        }

        initializeContext(): void {
            this.entityType = 'EmployeeTemplatePromotions';
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.employeeTemplatePromotion;
            this.sectionTemplatePath = 'app/plugins/employeeTemplatePromotions/sectionViews/';
            //this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_MAIN);
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new MainSection(0,
                    'SECTION_SERVICES_MAIN',
                    'main.html',
                    true,
                    false,
                    this.baseEndpoint,
                    '',
                    this.loggingService,
                    this.dataService,
                    this.$translate,
                    null,
                    Meevo.Model.NounEnum.EmployeePromotionMain,
                    this.employeeDetail,
                    this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_LOCATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new LocationSection(1,
                    'SECTION_EMPLOYEE_LOCATIONS',
                    'locations.html',
                    false,
                    false,
                    this.appSettings.API_ENDPOINTS.employeeTemplate,
                    'security',
                    this.loggingService,
                    this.dataService,
                    null,
                    Meevo.Model.NounEnum.EmployeePromotionSecurity,
                    null,
                    this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_LOCATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ ));
           if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new ServiceSection(2,
                    'SECTION_EMPLOYEE_SERVICES',
                    'services.html',
                    false,
                    false,
                    '',
                    '',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.EmployeePromotionServices,
                    this.appSettings,
                    this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.securityChecker));
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_PAYROLL + Meevo.Components.Common.SecurityParts.KEY_PART_READ) && !this.identityService.inCentralOfficeMode())
                this.sections.push(new CompensationSection(3,
                    'SECTION_EMPLOYEE_COMPENSATION',
                    'compensation.html',
                    false,
                    false,
                    '',
                    'compensation',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.EmployeePromotionCompensation,
                    this.modalService,
                    this.appSettings,
                    this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_PAYROLL + Meevo.Components.Common.SecurityParts.KEY_PART_READ ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_DEDUCTION + Meevo.Components.Common.SecurityParts.KEY_PART_READ) )
                this.sections.push(new DeductionSection(4,
                    'SECTION_EMPLOYEE_DEDUCTION',
                    'deduction.html',
                    false,
                    false,
                    '',
                    'deduction',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.EmployeePromotionDeductions,
                    null,
                    this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_DEDUCTION + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_SERVICECOMMISSIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new ServiceCommissionsSection(5,
                    "SECTION_EMPLOYEE_COMMISSIONS_OVERRIDE",
                    "servicesCommissions.html",
                    false,
                    false,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.EmployeePromotionCommissions, null, this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_SERVICECOMMISSIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
        }

        selectSection(item): void {
            switch (item.sectionId) {
                case 1:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_LOCATIONS);
                    break;
                case 2:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_SERVICES);
                    break;
                case 3:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_PAYROLL);
                    break;
                case 4:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_DEDUCTION);
                    break;
                case 5:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_SERVICECOMMISSIONS);
                    break;
                default:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_EMPLOYEETEMPLATEPROMOTION_TAB_MAIN, true, true);
                    break;
            }
            super.selectSection(item);
        }

        reinitializeSetcions(): void {
            this.sections = [];
            this.initializeSections();
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
        }

        // Security Role Management

        get isSecurityRoleRequired(): boolean {
            var empTemplate = this.castModel<Model.EmployeeTemplatePromotion>();
            return Model.Guard.isSomething(empTemplate) || empTemplate.template.securityRoles.length === 0;
        }

        // Category Management

        get isCategoryRequired(): boolean {
            var empTemplate = this.castModel<Model.EmployeeTemplatePromotion>();
            return Model.Guard.isSomething(empTemplate)
                && Model.Guard.isSomething(empTemplate.employeeCategories)
                && empTemplate.employeeCategories.length === 0;
        }

        addEmployeeCategotry(): void {
            var empTemplate = this.castModel<Model.EmployeeTemplatePromotion>();
            if (Model.Guard.isSomething(empTemplate)
                && Model.Guard.isSomething(empTemplate.employeeCategoryDetail)
                && _.find(empTemplate.employeeCategories, (ec) =>
                { return ec.displayName === empTemplate.employeeCategoryDetail.displayName }) === undefined) {
                {
                    empTemplate.employeeCategories.push(empTemplate.employeeCategoryDetail);
                    empTemplate.employeeCategoryDetail = undefined;
                }
            }
        }

        removeEmployeeCategory(index: number): void {
            var empTemplate = this.castModel<Model.EmployeeTemplatePromotion>();
            if (Model.Guard.isSomething(empTemplate))
                empTemplate.employeeCategories.splice(index, 1);
        }

        // Template Management

        get hasTemplates(): boolean {
            let promo = this.castModel<Model.EmployeeTemplatePromotion>();
            return Model.Guard.isSomething(promo) && Model.Guard.isSomething(promo.appliedTemplates) && promo.appliedTemplates.length > 0;
        }

        openApplyTemplateEditor(context: any) {
            // Initialize modal with employee resources
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/employee/sectionViews/applyTemplate.html',
                clickOutsideToClose: false,
                locals: {
                    context: context,
                    isClear: false
                },
                controller: 'meevo.plugins.employee.ApplyTemplateController',
                controllerAs: 'vm'
            }
            this.modalService.showCustom(options);
        }

        applyTemplate(appliedTemplate: Model.AppliedTemplate) {
            this.modalService.confirm('CONFIRMATION_APPLY_TEMPLATE_SETTINGS', ModalTranslationModes.Translate)
                .then((response: boolean) => {
                    this.loadingInProgress = true;
                    var uri = `/${this.appSettings.API_ROOT}/${this.baseEndpoint}/TemplateApply`;
                    // prepare request payload
                    let params = {
                        model: this.castModel<Model.EmployeeTemplatePromotion>(),
                        templateId: appliedTemplate.templateId,
                        isClear: false
                    }
                    return this.dataService.customMethodData(uri, 'PUT', params)
                        .then((res) => {
                            // update client side model
                            this.selectedSection.model = res.data;
                            // add to applied template collection
                            let promo = this.castModel<Model.EmployeeTemplatePromotion>();
                            if (Model.Guard.isNothing(_.find(promo.appliedTemplates, at => at.templateId === appliedTemplate.templateId))) {
                                promo.appliedTemplates.push(appliedTemplate);
                            }
                        })
                        .finally(() => { this.loadingInProgress = false });
                });
        }

        clearTemplate() {
            let clearMessage = 'This action will restore promotion fields to current employee profile values.<br/>Do you wish to continue?';

            this.modalService.confirm(clearMessage)
                .then((response: boolean) => {
                    this.loadingInProgress = true;
                    var uri = `/${this.appSettings.API_ROOT}/${this.baseEndpoint}/TemplateApply`;
                    // prepare request payload
                    let params = {
                        model: this.castModel<Model.EmployeeTemplatePromotion>(),
                        isClear: true
                    }
                    return this.dataService.customMethodData(uri, 'PUT', params)
                        .then((res) => {
                            // update client side model
                            this.selectedSection.model = res.data;
                            // reinitialize applied template collection
                            let promo = this.castModel<Model.EmployeeTemplatePromotion>();
                            promo.appliedTemplates = [];
                        })
                        .finally(() => { this.loadingInProgress = false });
                });
        }

        save(): angular.IPromise<any> {
            // get promotion model
            let promo = this.castModel<Model.EmployeeTemplatePromotion>();
            var that;
            that = this.sections[0];
            if (this.verifySelectedSectionModel) {               
                if (Model.Guard.isSomething) {
                    // update display name
                    promo.displayName = this.getPromotionDisplayName();
                }
            }
            if ((this.selectedSection.sectionId === 0) && (Model.Guard.isSomething(that.backup) || Model.Guard.isSomething(that.addCopyModel))) {
                let previousServicePriceLevel = this.isAdding ? that.addCopyModel.defaultServicePriceLevel : that.backup.defaultServicePriceLevel;
                    if (previousServicePriceLevel !== promo.defaultServicePriceLevel) {
                        this.modalService.alert("MESSAGE_MODAL_EMPLOYEE_PRICE_LEVELS_CHANGED", Meevo.Components.Modal.ModalTranslationModes.Translate, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                            .then((results: any) => {
                                if (results) {
                                    promo.changeAllServicePriceLevel = true;
                                    return super.save();
                                }
                            }).then(() => {
                                promo.changeAllServicePriceLevel = false;
                            }).finally(() => super.save());
                    }
                    else
                        return super.save();             
            }
            else
                return super.save();
        }

        getPromotionDisplayName(): string {
            // get main section
            var mainSection = <MainSection>this.sections[0];
            return Model.Guard.isSomething(mainSection) ? mainSection.createPromotionDisplayName() : null;
        }

        resetAfterSave(): void {
            var model = this.castModel<Model.EmployeeTemplatePromotion>();
            if (Model.Guard.isSomething(model) && model.processNow) {
                this.mode = Meevo.Model.MaintenanceFormState.Readonly;
                this.deactivate();
            }
        }

        postAdd(model: any): void {
            this.resetAfterSave();
        }

        postUpdate(model: any): void {
            this.resetAfterSave();
        }

        postDelete(): void {
            this.mode = Meevo.Model.MaintenanceFormState.Readonly;
            this.deactivate();
        }

        processNowChanged(): void {
            let cur = this.castModel<Model.EmployeeTemplatePromotion>();
            if (cur.processNow)
                cur.activeDate = moment().format();
        }

        get showEdit(): boolean {
            return super.showEditLogic() && Model.Guard.returnSomething(this.currentPromo.appliedDate) === null;
        }

        get showSave(): boolean {
            return super.showSaveLogic() && Model.Guard.returnSomething(this.currentPromo.appliedDate) === null;
        }

        get showDelete(): boolean {
            return this.selectedSection.sectionId === 0
                && super.showDeleteLogic() && Model.Guard.returnSomething(this.currentPromo.appliedDate) === null;
        }

        get showCopy(): boolean {
            return false;
        }

        get currentPromo(): Model.EmployeeTemplatePromotion {
            return this.castModel<Model.EmployeeTemplatePromotion>();
        }

    }
}